import myImg from "../../images/me.jpg";
import { motion } from "framer-motion";
import "./About.scss";

const containerVariants = {
  //initial state
  hide: {
    opacity: 0,
    y: "100vh",
  },
  //animate state
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.5,
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.3 },
  },
};

const aboutParaVariants = {
  hide: {
    opacity: 0,
    x: -50,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 1,
      duration: 0.7,
      ease: "linear",
    },
  },
};
const aboutPicVariants = {
  hide: {
    opacity: 0,
    x: 50,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 1,
      duration: 0.7,
      ease: "linear",
    },
  },
};

const About = () => {
  return (
    <>
      <motion.section
        className="about"
        variants={containerVariants}
        initial="hide"
        animate="show"
        exit="exit"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-10 mx-auto">
              <h1 className="about-h1 display-6 text-capitalize">
                a little bit about me
              </h1>
              <motion.div variants={aboutParaVariants}>
                <p className="about-para mt-3">
                  Hello! my name is Ahmer Altaf and i'm a web developer with a
                  passion for Front-End development.
                </p>
                <p className="about-para mt-3">
                  I graduated from{" "}
                  <a
                    href="https://www.bahria.edu.pk/bukc/"
                    target="_blank"
                    className="text-link"
                  >
                    Bahria University Karachi{" "}
                  </a>
                  and got a degree in software engineering. I developed many
                  web-based projects from simple landing pages to react web
                  applications and nft related websites for my clients. I love
                  learning new and better ways to create seamless user
                  experiences with clean, efficient, and scalable code.
                </p>
                <p className="about-para mt-3">
                  My primary goal is to create something beautiful with people
                  that bring out the best in me.
                </p>
                <p className="about-para mt-3">
                  When i'm not in front of a computer screen, i mostly play
                  football or hangout with family.
                </p>
                <p className="about-para mt-3">
                  I believe anything can be overcome through commitment and hard
                  work. Always up for learning new things.
                </p>
                <p className="about-para mt-3">
                  Here are few technologies i've been working with recently:
                </p>
                <div className="row">
                  <div className="col-md-6 col-10 mx-auto">
                    <ul className="about-list">
                      <li>HTML</li>
                      <li>JavaScript</li>
                      <li>Next Js</li>
                    </ul>
                  </div>
                  <div className="col-md-6 col-10 mx-auto">
                    <ul className="about-list">
                      <li>CSS / SCSS / TAILWIND</li>
                      <li>React / Redux</li>
                      <li>Nft minting dapps</li>
                    </ul>
                  </div>
                </div>
              </motion.div>
            </div>
            <motion.div
              className="col-md-4 col-10 mx-auto align-self-center pb-3"
              variants={aboutPicVariants}
            >
              <img src={myImg} alt="ahmer" className="img-fluid my-img" />
            </motion.div>
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default About;
